export class RemoveSplashAction {
  static readonly type = '[AppState] remove splash';
}
